import style from "./DataProjects.module.scss";

const DataProjects = () => {
  return (
    <div className={`sw ${style.wrapper}`}>
      <h2>Data Projects</h2>

      <div className={style.projects}>
        <div className={style.project}>
          <a
            className={style.project_link}
            href="https://github.com/barnascript/ab-testing_forest_prime/tree/main"
          >
            <h2 className={style.project_title}>
              Forest Prime: A/B Test Analysis Project
            </h2>
          </a>

          <p>
            Forest Prime is preparing for a promotion that will run in August
            this year and wants to analyze the data for the last 5 years of A/B
            ad campaigns that were used in August to better understand which
            campaigns led to more purchases. The marketing team noticed that the
            campaigns used in August 2019 led to the most sales overall and are
            requesting an analysis of whether the test or control campaign led
            to more sales.
          </p>
          <a href="https://github.com/barnascript/ab-testing_forest_prime/tree/main">
            Link to the Github Repository
          </a>
          <div className={style.tools}>
            ● Anaconda ● Jupyter Notebook ● Python ● Pandas ● Matplotlib ● Numpy
            ● Seaborn ● Github ● Data Gathering ● Data Assessing ● Data Cleaning
            ● Exploratory Data Analysis ● Hypotheses Testing ● Matplotlib ●
            Probability and Z-tests in Python
          </div>
        </div>
        <div className={style.project}>
          <a
            className={style.project_link}
            href="https://github.com/barnascript/missed_appointments"
          >
            <h2 className={style.project_title}>Medical Appointment Project</h2>
          </a>

          <p>
            This was my first project where I had to investigate a dataset. The
            dataset had information from 100K medical appointments in Brazil
            that focused on whether the patient showed up for their appointment
            or were a no-show for their appointment. All of my analysis is saved
            in a Jupyter Notebook.
          </p>
          <a href="https://github.com/barnascript/missed_appointments">
            Link to the Github Repository
          </a>
          <div className={style.tools}>
            ● Anaconda ● Jupyter Notebook ● Python ● Pandas ● Matplotlib ● Numpy
            ● Seaborn ● Github
          </div>
        </div>
        <div className={style.project}>
          <a
            className={style.project_link}
            href="https://github.com/barnascript/global_co2_emissions/blob/main/README.md"
          >
            <h2 className={style.project_title}>Global CO2 Emissions</h2>
          </a>

          <p>
            An Interactive project in Tableau where visualised Global CO2
            Emissions from Maven Analytics.
          </p>
          <a href="https://github.com/barnascript/global_co2_emissions/blob/main/README.md">
            Link to the Github Repository
          </a>
          <div className={style.tools}>
            ● Tableau ● Time Series ● Environment
          </div>
        </div>
        <div className={style.project}>
          <a
            className={style.project_link}
            href="https://github.com/barnascript/hr"
          >
            <h2 className={style.project_title}>HR Employment Analysis</h2>
          </a>

          <p>
            This project aims to leverage MySQL and Tableau for a comprehensive
            HR analysis, examining gender, race, termination rates, net change,
            city distribution, age, and average tenure to provide actionable
            insights into workforce dynamics and guide informed decision-making
            for organizational development.
          </p>

          <a href="https://public.tableau.com/views/HREmploymentDashboard/HREmploymentDashboard?:language=en-GB&publish=yes&:display_count=n&:origin=viz_share_link">
            Link to the Tableau Dashboard
          </a>
          <div className={style.tools}>
            ● Data Cleaning ● Data Modelling ● Exploratory Data Analysis (EDA) ●
            MySQL ● Tableau
          </div>
          <a href="https://github.com/barnascript/hr">Github Repo</a>
        </div>
        <div className={style.project}>
          <a
            className={style.project_link}
            href="https://github.com/barnascript/Walmart_sales_analysis/tree/main"
          >
            <h2 className={style.project_title}>Walmart Sales Analysis</h2>
          </a>

          <p>
            This project uses <b>MySQL</b> to explore the Walmart Sales data to
            understand top performing branches and products, sales trend of of
            different products, customer behaviour. The aims is to study how
            sales strategies can be improved and optimized. <br /> <br /> The
            dataset was obtained from the Kaggle Walmart Sales Forecasting
            Competition.
          </p>
          <div className={style.tools}>
            ● Data Wrangling ● Feature Engineering ● Exploratory Data Analysis
            (EDA)● MySQL
          </div>
          <a href="https://github.com/barnascript/Walmart_sales_analysis/tree/main">
            Github Repo
          </a>
        </div>
        <div className={style.project}>
          <a
            className={style.project_link}
            href="https://github.com/barnascript/Danny_dinner"
          >
            <h2 className={style.project_title}> Danny's Diner</h2>
          </a>

          <p>
            Danny wants to use the data to answer a few simple questions about
            his customers, especially about their visiting patterns, how much
            money they’ve spent and also which menu items are their favourite.
            Having this deeper connection with his customers will help him
            deliver a better and more personalised experience for his loyal
            customers. <br /> <br /> He plans on using these insights to help
            him decide whether he should expand the existing customer loyalty
            program - additionally he needs help to generate some basic datasets
            so his team can easily inspect the data without needing to use SQL.
          </p>
          <div className={style.tools}>
            ● Feature Engineering ● Exploratory Data Analysis (EDA) ● PostgreSQL
          </div>
          <a href="https://github.com/barnascript/Danny_dinner">Github Repo</a>
        </div>
      </div>
    </div>
  );
};

export default DataProjects;
